﻿document.addEventListener("DOMContentLoaded", function () {

    // Check if the browser is supported
    checkSupportedBrowser();

    if (/\/signup|\/free|\/logout|\/login|\/error|\/upgrade|\/admin|\/support|\/system/.test(window.location.pathname.toLowerCase()))
        return;

    // ┌────────────────────────────────────────────────────────────────────
    // │ Get the license for the tenant
    // └────────────────────────────────────────────────────────────────────
    DsCommon.loadLicense(function (license) {

        if (!license)
            return;

        about();

        if (license.isDeleted) {
            window.location.href = "/error/accountdeleted";
            return;
        }

        if (license.isExpired) {
            window.location.href = "/error/licenseinvalid";
            return;
        }

        if (license.isSuspended) {
            window.location.href = "/error/accountsuspended";
            return;
        }

        if (license.contactsPercentUsed > 1 && license.isFree) {
            document.location = '/error/ExceededLicensedContacts';
            return;
        }

        // show notifications in the header
        showHeaderNotifications(license);

        // Check the heartbeat
        heartbeat(license);

        // ┌────────────────────────────────────────────────────────────────────
        // │ Set powered by div for widgets
        // └────────────────────────────────────────────────────────────────────
        function about() {

            fetch(`/api/v1/about`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then(json => {

                const e = "\ndisplay: inline-block;font-size: 14px;background: linear-gradient(to right, #805cfb, #397deb);color: white;padding: 4px;border-radius: 4px;";
                let t = "\n";
                t += `⭐ Tenant Name: ${json.tenant}\n`,
                    t += `⭐ Tenant Id: ${json.id}\n`,
                    t += `⭐ Tenant UUID: ${json.uid}\n`,
                    t += `⭐ Build Version: ${json.build_version}\n`,
                    t += "\nLearn more at: https://www.dailystory.com/\n",
                    console.group("%cDailyStory Marketing Automation", e),
                    console.log(`%c ${t}`, "font-size: 14px;"),
                    console.groupEnd();
            });
        }

        // ┌────────────────────────────────────────────────────────────────────
        // │ Show notifications in the header
        // └────────────────────────────────────────────────────────────────────
        function showHeaderNotifications(license) {

            if (window.location.pathname.toLowerCase() != '/')
                return;

            if (!isAccountVerified(license)) {
                return;
            }

            if (isFree(license)) {
                return;
            }

            if (isExpiringSoon(license)) {
                return;
            }

            if (!isPositiveSmsCredits(license)) {
                return;
            }

            if (isContactsExceeded(license)) {
                return;
            }

            if (isStaging(license)) {
                return;
            }

            getAnnouncements();

            // Does the account have a positive sms credit balance
            function isPositiveSmsCredits(license) {

                if (license.smsCreditsRemaining >= 0)
                    return true;

                let purchased = parseInt(license.license.PurchasedTextMessages)
                let balance = purchased / 100;

                if (license.smsCreditsRemaining < 0)
                    window.location.href = `/error/negativebalance?service=sms&amount=${balance}`;

                let div = document.getElementById('header_notification');
                div.classList.add('text-center');
                div.classList.add('license-warning');
                div.innerHTML = `Your text message credit balance is <strong>${balance.toLocaleString()}</strong> <a href="/admin/usage?buy=sms">please purchase more credits</a> to avoid a disruption in service`;
                div.style.display = 'block';

                return false;
            }

            // License is free
            function isFree(license) {
                if (!license.isFree)
                    return false;

                let div = document.getElementById('header_notification');
                div.classList.add('license-upgrade-container');
                div.innerHTML = `✨ Unlock all the capabilities of DailyStory and <a href="/upgrade">upgrade your Trial Account</a> ✨`;
                div.style.display = 'block';
                return true;
            }

            // Staging Environment
            function isStaging(license) {
                if (!license.isStaging)
                    return false;

                let div = document.getElementById('header_notification');
                div.classList.add('text-center');
                div.classList.add('license-danger');
                div.innerHTML = `🚧 Environment configured as Test / Staging - No outbound enabled 🚧`;
                div.style.display = 'block';
                return true;
            }

            // License is expiring soon
            function isExpiringSoon(license) {
                if (!license.isExpiringSoon)
                    return false;

                let div = document.getElementById('header_notification');
                div.classList.add('text-center');
                div.classList.add('license-danger');
                div.innerHTML = `Your service is scheduled to end on ${new Date(license.license.Expiration).toDateString()}`;
                div.style.display = 'block';

                return true;
            }

            // Licensed number of contacts is exceed
            function isContactsExceeded(license) {

                if (license.contactsPercentUsed <= 1)
                    return false;

                let div = document.getElementById('header_notification');
                div.classList.add('text-center');
                div.classList.add('license-warning');
                div.innerHTML = '<strong>warning</strong> licensed number of active contacts exceeded · <a href="/admin/usage">please review your license usage</a> to avoid a disruption in service';
                div.style.display = 'block';

                let percent_over = Math.abs(1 - license.contactsPercentUsed);

                console.warn(`DailyStory licensed contacts exceeded by: ${percent_over * 100}%`);

                return true;
            }

            // Account is not verified
            function isAccountVerified(license) {

                if (license.isVerified)
                    return true;

                let div = document.getElementById('header_notification');

                if (!div)
                    return;

                div.classList.add('text-center');
                div.classList.add('license-danger');
                div.innerHTML = 'Free Trial Not Verified · <a href="/verification">Verify Your Account</a>';
                div.style.display = 'block';

                return false;
            }

            // Announcements
            function getAnnouncements() {

                let key = 'license-news';

                let div = document.getElementById('header_notification');

                if (!div)
                    return;

                fetch(`/api/v1/about/announcements/`, {
                    method: 'GET'
                })
                    .then(response => response.json())
                    .then(json => {
                        if (json.Status) {

                            let update = json.Response.update;

                            let key_value = localStorage.getItem(key)

                            if (key_value && key_value == update.id)
                                return;

                            if (0 == update.id)
                                return;

                            if (null != key_value && parseInt(key_value) < parseInt(update.id))
                                return;

                            div.classList.add('license-news-container');

                            div.innerHTML = `<div class="license-news"><a href="${update.url}" target="_blank" style="text-align:center;width:100%"><span class="pill solid-green uppercase">${update.pill}</span>${update.message}</a><a class="close-news" href="#"><i class="fa-solid fa-xmark-large"></i></a></div>`;

                            div.querySelector('.close-news').addEventListener('click', () => {
                                let div = document.getElementById('header_notification');
                                div.style.display = 'none';

                                localStorage.setItem(key, update.id);
                            });
                        }
                    });
            }
        }

    });


    // ┌────────────────────────────────────────────────────────────────────
    // │ Ensure we are logged in to the tenant that the page is currently on
    // └────────────────────────────────────────────────────────────────────
    function heartbeat(license) {
        setInterval(async function () {
            if (document.visibilityState !== 'visible') return;

            try {
                const response = await fetch(`/api/v1/heartbeat/${license.tenantuid}`, {
                    method: 'GET'
                });

                if (!response.ok) {
                    DsUtility.loginPopupOn("Signed Out", `It appears you are signed out. Please <a target="_blank" href="/login">sign back in to <strong>${license.name}</strong></a> to continue.`);
                    return;
                }

                const json = await response.json();

                if (json.Status) {
                    DsUtility.loginPopupOff();
                    return;
                }

                // Status=false: signed out, or signed into a different tenant
                if (!json.Response?.is_authenticated)
                    DsUtility.loginPopupOn("Signed Out", `It appears you are signed out. Please <a target="_blank" href="/login">sign back in to <strong>${license.name}</strong></a> to continue.`);
                else
                    DsUtility.loginPopupOn("Signed Out", `You are signed in to the account: <strong>${json.Message}</strong>. Please <a target="_blank" href="/login">sign back in to <strong>${license.name}</strong></a> to continue.`);
            } catch (err) {
                // transient network error — let the next tick retry
                console.warn('heartbeat failed', err);
            }
        }, 60000);
    }
});

// ┌────────────────────────────────────────────────────────────────────
// │ Returns browser name and version
// └────────────────────────────────────────────────────────────────────
function getBrowserVersion() {
    const browser = {
        name: null,
        version: null
    };

    var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];

        browser.name = 'IE';
        browser.version = (tem[1] || '');
        return browser;
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem !== null) {
            browser.name = tem[0].replace('OPR', 'Opera');
            browser.version = tem[1];
            return browser;
        }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
        M.splice(1, 1, tem[1])
    };

    browser.name = M[0];
    browser.version = M[1];
    return browser;
}

// ┌────────────────────────────────────────────────────────────────────
// │ Checks if the browser is supported, if not redirects to error page
// └────────────────────────────────────────────────────────────────────
function checkSupportedBrowser () {

    let valid = true;
    browser = getBrowserVersion();

    switch (browser.name) {
        case "Chrome":
            if (browser.version < 60) 
                valid = false;
            break;
        case "IE":
            if (browser.version < 12)
                valid = false;
            break;
        case "Safari":
            if (browser.version < 11)
                valid = false;
            break;
        case "Firefox":
            if (browser.version < 50)
                valid = false;
            break;
    }

    if (!valid) {
        window.location.href = "/error/upgrade";
    }
}